function initApp() {
    var app = new Vue({
      el: '#brand-filter',
  
      data: {
        brands: settings,
        filters: "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z".split(','),
        toggleAll: false,
        results: []
      },
  
      computed: {
        imagebrands: function() {
          var _this = this;
          return _this.brands.filter(function(block) {
            return block.type == 'image_block';
          });
        }
      },
  
      mounted: function() {
        var _this = this;
      },
  
      methods: {
        filterBrandsByNumber: function(e) {
          var _this = this;
          var results = _this.brands.filter(function(brand) {
            return !isNaN(brand.title[0]);
          });
          
          _this.$set(_this, 'results', results);
          _this.$set(_this, 'toggleAll', false);
        },
        
        filterBrandsByLetter: function(letter) {
          var _this = this;
          var results = _this.brands.filter(function(brand) {
            return brand.title.toLowerCase().startsWith(letter) && brand.type !== 'image_block';
          });
          
          return results;
        },
  
        filterBrands: function(e, letter) {
          var _this = this;
          var results = _this.filterBrandsByLetter(letter);
  
          $('.brand-list-filters .menu__link button').removeClass('selected');
          $(e.currentTarget).addClass('selected');
          
          _this.$set(_this, 'results', results);
          _this.$set(_this, 'toggleAll', false);
        },
        
        filterAll: function(e) {
          var _this = this;
                  
          $('.brand-list-filters .menu__link button').removeClass('selected');
          $(e.currentTarget).addClass('selected');
          
          
          var allBrands = _this.brands.filter(function(item) {
            return item.title !== '' && item.type !== 'image_block'; 
          });
          
          _this.$set(_this, 'results', !_this.toggleAll ? allBrands : []);
          _this.$set(_this, 'toggleAll', !_this.toggleAll);
        }
      },
  
      filters: {
        resize: function(src, size) {
          var resized = src || '';
          resized = resized.replace('.png', `_${size}.png`);
          resized = resized.replace('.jpg', `_${size}.jpg`);
          return resized;
        },
  
        handle: function(value) {
          return value.toLowerCase().replace(' ', '-');
        },
  
        unhandle: function(value) {
          return value.replace('-', ' ');
        },
  
        upcase: function(value) {
          return value.toUpperCase();
        }
      }
    });
  }
  
  setTimeout(initApp, 0);
  
  document.addEventListener('shopify:section:load', initApp);